import { memo } from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

const ProgressBar = memo(({ color = 'success', progress, slots, sx }) => {
	return (
		<Box
			sx={{
				...sx,
				maxWidth: '50%',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				border: '1px solid',
				borderColor: 'rgba(224, 224, 224, 1)',
				borderRadius: '12px',
			}}
		>
			<Typography sx={{ ...slots.label?.sx }}>
				Completion Progress
			</Typography>
			<Box
				sx={{
					...slots.bar?.sx,
					display: 'flex',
					alignItems: 'center',
				}}
			>
				<Typography>{progress}%</Typography>
				<Box sx={{ width: '100%', ml: 1, mr: 1 }}>
					<LinearProgress
						color={color}
						variant='determinate'
						value={progress}
					/>
				</Box>
				<Typography>100%</Typography>
			</Box>
		</Box>
	);
});

export { ProgressBar };